<template>
  <div class="vote-info">
        <div class="vote_btn" style="text-align: right;margin-bottom: 10px;">
            <el-button v-if="canEdit" type="primary" size="small" @click="addVote">添加会议决议</el-button>
            <el-button size="small" @click="exportVote">导出</el-button>
        </div>
        <div v-loading="loading" class="vote_main">
            <el-table :data="listData" border style="width: 100%">
                <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                <el-table-column prop="voteTheme" label="会议决议标题" align="left"></el-table-column>
                <el-table-column prop="startTime" label="开始时间" width="130" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.startTime | timeFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="130" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.endTime | timeFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="voteNum" label="投票人数" width="100" align="center"></el-table-column>
                <el-table-column prop="voteStatus" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.voteStatus | voteStatusFilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="决议结果" width="100" align="center">
                    <template slot-scope="scope">
                        <span style="color: #1a82e3;cursor: pointer" @click="voteResult(scope.row)">统计</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="canEdit" prop="price" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="deleteVote(scope.row)">删除</el-link>
                        <el-link :underline="false" @click="editVote(scope.row)">修改</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Basicform
            v-if="isShowForm"
            :title="'会议决议'"
            :toolbar-btns="busiformBtns"
            :append-to-body="true"
            :win-width="moduleInfo.winWidth"
            :win-height="moduleInfo.winHeight"
            :module-code="moduleInfo.moduleCode"
            :on-basic-form-before-open="onBasicFormBeforeOpen"
            :on-basic-form-opened="onBasicFormOpened"
            :on-basic-form-before-submit="onBasicFormBeforeSubmit"
            :on-basic-form-submited="onBasicFormSubmited"
            >
            <template #default="slotProps">
                <busi-form ref="busFormJxzb" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
        <StatisticsVote />
  </div>
</template>

<script>
const moment = require('moment')
import StatisticsVote from './statisticsVote.vue'
export default {
    filters: {
        voteStatusFilter(val) {
            // 1：未开始 2：进行中 3：已结束 4：已下架
            if (val == 1) {
                return '未开始'
            } else if (val == 2) {
                return '进行中'
            } else if (val == 3) {
                return '已结束'
            } else if (val == 4) {
                return '已下架'
            } else {
                return ''
            }
        },
        timeFormat(val) {
            return moment(new Date(val)).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {
        StatisticsVote
    },
    props: {
        row: {
            type: Object,
            default: () => {}
        },
        canEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            isShowForm: false,
            listData: [],
            loginUser: this.$store.getters.loginUser,
            busiformBtns: [],
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/vote/form_hyjy.html',
                'winWidth': 1000,
                'delUrl': '/hygl/vote/delete',
                'addNewUrl': '/hygl/vote/addNew',
                'insertUrl': '/hygl/vote/insert',
                'moduleCode': 'vote',
                'winHeight': 600,
                'updateUrl': '/hygl/vote/update',
                'listDataUrl': '/hygl/vote/listdata',
                'getByIdUrl': '/hygl/vote/getById',
                'ytId': this.row.ytId
            }
        }
    },
    created() {
        this.getTableData()
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        meetInfoSixth() {
            this.getTableData()
        },
        async getTableData() {
            var params = {
                pageNum: 1,
                pageSize: 999,
                urlsearch: `hyapId:${this.row.id}`
            }
            const res = await this.$app.listdata('/hygl/vote/listdata', params)
            if (res.code === 'success') {
                this.listData = res.body.pageInfo.list
            }
        },
        addVote() {
            var _this = this
            _this.isShowForm = true
            _this.busiformBtns = [
                { id: 'btn_close', btnName: '关 闭', btnIcon: 'close', btnClick: 'closeDialog', btnPermission: '', btnType: ''},
                { id: 'btn_save', btnName: '保 存', btnIcon: 'check', btnClick: 'submitBusiform', btnPermission: 'saveObject', btnType: 'primary'}
            ]
            _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.vote.form_hyjy.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1, (res) => {
                    _this.getTableData()
                    _this.isShowForm = false
                })
            })
        },
        editVote(row) {
            var _this = this
            _this.isShowForm = true
            _this.busiformBtns = [
                { id: 'btn_close', btnName: '关 闭', btnIcon: 'close', btnClick: 'closeDialog', btnPermission: '', btnType: ''},
                { id: 'btn_save', btnName: '保 存', btnIcon: 'check', btnClick: 'submitBusiform', btnPermission: 'saveObject', btnType: 'primary'}
            ]
            _this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.vote.form_hyjy.vue?sysCode='
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, row, 1, (res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                    }
                    _this.getTableData()
                    _this.isShowForm = false
                })
            })
        },
        deleteVote(row) {
            this.$confirm('是否确认删除此会议决议？', '操作提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'post',
                    url: this.moduleInfo.delUrl,
                    params: {
                        id: row.id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.getTableData()
                        this.isShowForm = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                // do nothing
            })
        },
        // 统计
        voteResult(row) {
            this.$bus.emit('openStatisticsVote', row)
        },
        // 导出
        exportVote() {
            window.open(`/apigw/hygl/vote/exportdata?pageSize=65000&pageNum=1&listpageViewUrl=hygl.vote.list_mT3PHL.vue&searchAndOr=&fileName=${this.$route.meta.tagTitle}&httpPort=${location.port}&urlsearch=hyapId:${this.row.id}`)
        },
        /**
        * 表单打开检查，vo为已加载salary对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
        */
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的salary对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
        */
        onBasicFormOpened: function($scope, vo) {
            $scope.title = '会议决议'
            if (process.env.NODE_ENV === 'development') console.log('salary form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的salary对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            vo.voteRange = 4
            vo.status = 1

            if (!vo.startTime || !vo.endTime) {
                this.$alert('开始-结束时间是必须的。', this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                defer.resolve(false)
                return
            }

            if (!vo.hyapId) vo.hyapId = this.row.id

            if (!vo.account) {
                vo.account = $scope.loginUser.personAccount
                vo.sponsor = $scope.loginUser.personName
                vo.voteStatus = 1
            }
            if (!vo.creatTime) vo.creatTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')

            console.log('$scope', $scope)
            defer.resolve(true)
        },
        /**
        * 表单提交完成，vo为已保存成功的salary对象，窗口即将关闭，不需要返回值
        */
        onBasicFormSubmited: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('salary form submited')
        }
    }
}
</script>

<style scoped lang="scss">

</style>
